import { Grid } from "@material-ui/core"
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
  ModalDeleteConfirm,
} from "App/Component/ui"

import {
  DISABLED_BUTTON_SUBMIT,
  instance2,
  instanceVclaim,
} from "App/constants"
import React, { useState } from "react"
import { prefixNoRM, sebabSakitSelect, useDiagnosa } from "../../../utils"
import {
  defaultStateSep,
  getPembiayaanName,
  getTujuanKunjungan,
  handleClickCetakSep,
} from "./helpers"

import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import { PilihDPJPLayanan } from "./SelectOption/PilihDPJPLayanan"
import { FormHanyaJikaLakaLantas } from "./FormHanyaJikaLakaLantas"
import { FormHanyaJikaRawatJalan } from "./RawatJalan/Form"
import { FormHanyaJikaRawatInap } from "./RawatInap/Form"
import { getUserName } from "App/utils/cookies"
import { checkSEP, deleteSep, updateSep } from "./api"
import { useSelector } from "react-redux"
import { itSelfEmpty } from "utils/all"
import { ModalForceSEP } from "./ModalForceSEP"
import { FormSEPManual } from "./FormSEPManual"
import moment from "moment"
import ListSEPInternal from "./ListSEPInternal"

const btnLabelHapus = {
  color: "#CC2B1D",
  state: false,
  label: "HAPUS",
}

const btnLabelUbah = {
  color: "#0FB054",
  state: false,
  label: "UBAH",
}

export const FormSEP = ({
  formData,
  handleChange,
  setFormData,
  url,
  type,
  handleClickPrint,
  handleChangeSep,
  handleClickNoKontrol,
  handleClickMultiNoRujukan,
  handleClickNoRujukan,
  updateRegistrasi,
  handleClickSepSuplesi,
  handleClickRujukanKhusus,
}) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [loadingHapus, setLoadingHapus] = useState(btnLabelHapus)
  const [loadingUbah, setLoadingUbah] = useState(btnLabelUbah)
  const [showModalDuplikasiSEP, setShowModalDuplikasiSEP] = useState({
    state: false,
    message: "",
  })
  const [openData, setOpenData] = useState(false)
  const [modalConfrim, setModalConfrim] = useState(false)
  const [sepPrev, setSepPrev] = useState("")

  const handleSubmit = async (forceDelete = undefined) => {
    setLoadingSubmit(true)
    if (!isNull(forceDelete) && (type === "IGD" || type === "RI")) {
      const apiCheckSEP = await checkSEP(formData.id_registration)
      if (apiCheckSEP.state) {
        setSepPrev(apiCheckSEP.data)
        setModalConfrim(true)
        setLoadingSubmit(false)
      } else {
        handleSubmit(false)
      }
    } else {
      const createDate = moment().format("YYYY-MM-DD")
      const isBackDate = createDate !== moment(formData.tgl_sep)

      try {
        if (type === "MANUAL") {
          try {
            const penanggung_jawab =
              getPembiayaanName(formData.pembiayaan).length > 0
                ? getPembiayaanName(formData.pembiayaan)[0]
                : {
                    label: "",
                  }
            const payloads = {
              ppk_pelayanan: process.env.REACT_APP_KODE_PPK_RUJUKAN,
              jenis_pelayanan: "2",
              no_mr: formData.patientID.toString(),
              nomor_kartu: formData.no_kartu,
              nomor_telp: formData.no_tlp,
              tgl_sep: formData.tgl_sep,
              tgl_rujukan: formData.tgl_rujukan,
              nomor_rujukan: formData.no_rujukan,
              ppk_rujukan: formData.ppk_rujukan_kode,
              catatan: formData.catatan,
              diagnosa_awal: formData.diagnosa_awal,
              tujuan: formData.kode_poliklinik,
              eksekutif: "0",
              pembiayaan: formData.pembiayaan.toString(),
              penanggung_jawab: penanggung_jawab.label,
              asal_rujukan: formData.asal_rujukan.toString(),
              kls_rawat_hak: itSelfEmpty(formData.kls_rawat_hak),
              kls_rawat_naik: itSelfEmpty(formData.kls_rawat_naik),
              kls_rawat_naik_name: itSelfEmpty(formData.kls_rawat_naik_name),
              cob: formData.cob ? "1" : "0",
              laka_lantas: formData.laka_lantas.toString(),
              tgl_kejadian: formData.tgl_kejadian,
              katarak: formData.katarak ? "1" : "0",
              keterangan: formData.keterangan,
              suplesi: itSelfEmpty(
                formData?.suplesi,
                "",
                formData?.suplesi?.toString(),
              ),
              nomor_sep_suplesi: formData.nomor_sep_suplesi,
              kode_propinsi: itSelfEmpty(formData.kode_propinsi),
              nama_propinsi: formData.nama_propinsi,
              kode_kabupaten: itSelfEmpty(formData.kode_kabupaten),
              nama_kabupaten: formData.nama_kabupaten,
              kode_kecamatan: itSelfEmpty(formData.kode_kecamatan),
              nama_kecamatan: formData.nama_kecamatan,
              tujuan_kunjungan: getTujuanKunjungan(
                type,
                formData.tujuan_kunjungan,
              ),
              flag_procedure: formData.flag_procedure.toString(),
              kode_penunjang: formData.kode_penunjang.toString(),
              assesment_pel: formData.assesment_pel.toString(),
              nomor_surat: formData.nokontrol ?? "",
              kode_dpjp: isNull(formData.kode_dpjp)
                ? ""
                : formData.kode_dpjp.toString(),
              dpjp_layanan: isNull(formData.dpjp_layanan_kode)
                ? ""
                : formData.dpjp_layanan_kode.toString(),

              user: getUserName(),
              isBackDate: isBackDate,
              createDate: createDate,
            }

            const api = await instanceVclaim.post(url, payloads)
            if (!isNull(api.data.response)) {
              // if (api.data.status === 206) {
              //   setShowModalDuplikasiSEP({
              //     state: true,
              //     message: api.data.message,
              //   });
              // }

              defaultToastSuccess(api?.data?.metaData?.message)
              setLoadingSubmit(false)
              setFormData({
                ...formData,
                no_sep: api?.data?.response?.sep?.noSep,
                poli_tujuan_print: `${formData.kode_poliklinik} - ${formData.nama_poliklinik}`,
              })
              handleChangeSep(api?.data?.response?.sep?.noSep)
            } else {
              setLoadingSubmit(false)
              defaultToastError(api?.data?.metaData?.message)
            }
          } catch (err) {
            setLoadingSubmit(false)
            defaultToastError(err?.response?.data?.metaData?.message)
          }
        } else {
          const api = await instance2.post(url, {
            id_registration: formData.id_registration,
            hak_kelas: formData.kode_hak_kelas,
            nama_hak_kelas: formData.hak_kelas,
            kode_ppk_perujuk: formData.ppk_rujukan_kode,
            nama_ppk_perujuk: formData.ppk_rujukan_name,
            forceDelete: forceDelete,
            request: {
              ...defaultPayload(),
              isBackDate: isBackDate,
              createDate: createDate,
            },
          })
          if (api.data.status === 200 || api.data.status === 206) {
            // if (api.data.status === 206) {
            //   setShowModalDuplikasiSEP({
            //     state: true,
            //     message: api.data.message,
            //   });
            // }

            defaultToastSuccess(api.data.message)
            setLoadingSubmit(false)
            setFormData({
              ...formData,
              no_sep: api.data.response.response.sep.noSep,
              poli_tujuan_print: `${formData.kode_poliklinik} - ${formData.nama_poliklinik}`,
            })
            handleChangeSep(api.data.response.response.sep.noSep)
          } else if (api.data.status === 203 || api.data.status === 204) {
            setModalConfrim(true)
          } else {
            setLoadingSubmit(false)
            defaultToastError(api.data.message.metaData.message)
          }
        }
      } catch (error) {
        setLoadingSubmit(false)
        if (!isNull(error.response.data.message.metaData)) {
          defaultToastError(error.response.data.message.metaData.message)
        } else {
          defaultToastError(error.response.data.message)
        }
      }
    }
  }

  const noSep = formData.no_sep
  const { diagnosa, loading } = useDiagnosa(formData.diagnosa_name)
  const alreadySEP = !isNull(noSep) && noSep !== "-"
  const { access } = useSelector((state) => state)

  const hapusSep = async () => {
    setLoadingHapus(DISABLED_BUTTON_SUBMIT)
    const response = await deleteSep(noSep)
    if (response.state) {
      await updateRegistrasi(noSep)
      setFormData({
        ...formData,
        no_sep: "-",
      })
      handleChangeSep("")
      setLoadingHapus(btnLabelHapus)
      defaultToastSuccess("SEP Berhasil dihapus")
    } else {
      setLoadingHapus(btnLabelHapus)
      defaultToastError(response.message)
    }
  }

  const ubahSep = async () => {
    setLoadingUbah(DISABLED_BUTTON_SUBMIT)
    const validDiagnosa = formData?.diagnosa_awal_name?.split(" - ")

    if (validDiagnosa.length === 0) {
      return defaultToastError("diagnosa tidak valid")
    }

    if (
      !isNull(formData?.laka_lantas) &&
      formData?.laka_lantas?.toString() !== "0"
    ) {
      if (isNull(formData?.tgl_kejadian)) {
        setLoadingUbah(btnLabelUbah)
        return defaultToastError("Tanggal Kejadian Tidak Boleh Kosong")
      } else if (new Date(formData.tgl_kejadian) > new Date(formData.tgl_sep)) {
        setLoadingUbah(btnLabelUbah)
        return defaultToastError(
          "Tanggal Kejadian Tidak Boleh Lebih Besar Dari Tanggal SEP",
        )
      }
    }

    const response = await updateSep({
      ...defaultPayload(),
      nomor_sep: noSep,
      no_mr: prefixNoRM(formData?.patientID),
      diagnosa_awal: validDiagnosa[0],
      nomor_telp: formData?.no_tlp,
    })
    if (response.state) {
      await updateRegistrasi(noSep)
      setLoadingUbah(btnLabelUbah)
      defaultToastSuccess("SEP Berhasil diUbah")
    } else {
      setLoadingUbah(btnLabelUbah)
      defaultToastError(response.message)
    }
  }

  const defaultPayload = () => {
    const penanggung_jawab =
      getPembiayaanName(formData.pembiayaan).length > 0
        ? getPembiayaanName(formData.pembiayaan)[0]
        : {
            label: "",
          }
    return {
      tgl_sep: formData.tgl_sep,
      tgl_rujukan: formData.tgl_rujukan,
      nomor_rujukan: type !== "IGD" ? formData.no_rujukan : "",
      ppk_rujukan: formData.ppk_rujukan_kode,
      catatan: formData.catatan,
      diagnosa_awal: formData.diagnosa_awal,
      tujuan: formData.kode_poliklinik,
      eksekutif: "0",
      /**
       * Hanya Jika RJ
       */
      pembiayaan: type === "RJ" ? "" : formData.pembiayaan.toString(),
      penanggung_jawab: type === "RJ" ? "" : penanggung_jawab.label,
      asal_rujukan: formData.asal_rujukan.toString(),
      /**
       * End Hanya Jika RJ
       */
      /**
       * Hanya Jika RI
       */
      kls_rawat_hak: itSelfEmpty(formData.kls_rawat_hak),
      kls_rawat_naik: itSelfEmpty(formData.kls_rawat_naik),
      kls_rawat_naik_name: itSelfEmpty(formData.kls_rawat_naik_name),
      /**
       * End Hanya Jika RI
       */
      cob: formData.cob ? "1" : "0",
      laka_lantas: formData.laka_lantas.toString(),
      tgl_kejadian: formData.tgl_kejadian,
      katarak: formData.katarak ? "1" : "0",
      keterangan: formData.keterangan,
      suplesi: itSelfEmpty(
        formData?.suplesi,
        "",
        formData?.suplesi?.toString(),
      ),
      // nama_suplesi: formData.nama_suplesi,
      nomor_sep_suplesi: formData.nomor_sep_suplesi,
      kode_propinsi: itSelfEmpty(formData.kode_propinsi),
      nama_propinsi: formData.nama_propinsi,
      kode_kabupaten: itSelfEmpty(formData.kode_kabupaten),
      nama_kabupaten: formData.nama_kabupaten,
      kode_kecamatan: itSelfEmpty(formData.kode_kecamatan),
      nama_kecamatan: formData.nama_kecamatan,
      tujuan_kunjungan: getTujuanKunjungan(type, formData.tujuan_kunjungan),
      flag_procedure: formData.flag_procedure.toString(),
      kode_penunjang: formData.kode_penunjang.toString(),
      assesment_pel: type !== "RJ" ? "" : formData.assesment_pel.toString(),
      /**
       * jika rj ambil dari no surat kontrol
       * jika ri tidak ada no surat kontrol, tapi digabung jadi norujukan
       *
       */
      nomor_surat: type !== "IGD" ? formData.nokontrol : "",
      /**
       * RAWAT JALAN
       *
       * jika pasien baru kode_dpjp dan dpjp_layanan ambil dari registrasi
       *
       * jika pasien kontrol
       * kode_dpjp ambil dari ep bpjs langsung
       * dpjp_layanan input tapi default dari regis
       *
       */
      kode_dpjp: isNull(formData.kode_dpjp)
        ? ""
        : formData.kode_dpjp.toString(),
      dpjp_layanan: isNull(formData.dpjp_layanan_kode)
        ? ""
        : formData.dpjp_layanan_kode.toString(),

      user: getUserName(),
    }
  }

  return (
    <>
      {showModalDuplikasiSEP.state && (
        <ModalDeleteConfirm
          title="Duplikasi SEP"
          labelConfirm="Ya, saya mengerti"
          msg={showModalDuplikasiSEP.message}
          confirmHandle={() =>
            setShowModalDuplikasiSEP({
              state: false,
              message: "",
            })
          }
        />
      )}
      {modalConfrim.state && (
        <ModalForceSEP
          setShowModalForce={setModalConfrim}
          handleForce={handleSubmit}
          sepPrev={sepPrev}
        />
      )}

      <Grid item xs={6}>
        {/* is prolanis PRB */}
        {formData.prolanisPRB && (
          <CardProlanisPRB label={formData.prolanisPRB} />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: "24px",
              fontWeight: "600",
            }}
          >
            No SEP : {noSep}
          </p>
          <MasterButton
            name="List rujukan khusus"
            type="button"
            onClick={handleClickRujukanKhusus}
          />
        </div>
        <Grid container spacing={1}>
          {type === "IGD" && (
            <Grid item sm={4}>
              <InputTextMaster
                name="asal_rujukan"
                label="PPK ASAL RUJUKAN"
                id="asal_rujukan"
                value={formData.ppk_rujukan_name}
                onChange={handleChange("asal_rujukan")}
                placeholder=""
                disabled={true}
                readOnly={true}
              />
            </Grid>
          )}

          {type === "RJ" || type === "MANUAL" ? (
            <Grid item sm={4}>
              <InputOptionMaster
                name="asal_rujukan"
                label="PPK ASAL RUJUKAN"
                id="asal_rujukan"
                needParse={false}
                value={formData.asal_rujukan}
                onChange={handleChange("asal_rujukan")}
                data={[
                  {
                    value: "1",
                    label: "Klinik / Puskesmas",
                  },
                  {
                    value: "2",
                    label: "Rumah Sakit",
                  },
                ]}
                placeholder=""
              />
            </Grid>
          ) : (
            <></>
          )}
          <Grid item sm={3}>
            <InputTextMaster
              name="tgl_sep"
              label="TGL SEP"
              id="tgl_sep"
              type="date"
              readOnly={type === "RI" || type === "MANUAL" ? false : true}
              disabled={type !== "RI" || type === "MANUAL" ? false : true}
              value={formData.tgl_sep}
              onChange={handleChange("tgl_sep")}
              placeholder=""
            />
          </Grid>
          <Grid item sm={5}>
            <Grid container style={{ marginTop: "1rem" }}>
              <Grid item sm={12} md={6} lg={4}>
                <InputCheckboxMaster
                  checked={formData.cob}
                  name="cob"
                  id="cob"
                  label="COB"
                  onChange={() =>
                    setFormData({
                      ...formData,
                      cob: !formData.cob,
                    })
                  }
                />
              </Grid>
              {type === "RI" || type === "MANUAL" ? (
                <Grid item sm={12} md={12} lg={4}>
                  <InputCheckboxMaster
                    checked={formData.is_bayi}
                    name="is_bayi"
                    id="is_bayi"
                    label="Bayi"
                    onChange={() =>
                      setFormData({
                        ...formData,
                        is_bayi: !formData.is_bayi,
                      })
                    }
                  />
                </Grid>
              ) : (
                <></>
              )}
              <Grid item sm={12} md={6} lg={4}>
                <InputCheckboxMaster
                  checked={formData.katarak}
                  name="katarak"
                  id="katarak"
                  label="KATARAK"
                  onChange={(e) => {
                    const isChecked = e.target.checked
                    setFormData({
                      ...formData,
                      katarak: !formData.katarak,
                      kode_poliklinik: isChecked ? "MAT" : null,
                      nama_poliklinik: isChecked ? "MATA" : "Pilih Poliklinik",
                    })
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <FormSEPManual
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            type={type}
            handleClickNoKontrol={handleClickNoKontrol}
            handleClickMultiNoRujukan={handleClickMultiNoRujukan}
          />

          <FormHanyaJikaRawatJalan
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            type={type}
            handleClickNoKontrol={handleClickNoKontrol}
            handleClickMultiNoRujukan={handleClickMultiNoRujukan}
          />

          <PilihDPJPLayanan
            formData={formData}
            setFormData={setFormData}
            type={type}
          />

          <FormHanyaJikaRawatInap
            formData={formData}
            handleChange={handleChange}
            type={type}
            setFormData={setFormData}
            handleClickNoKontrol={handleClickNoKontrol}
            handleClickNoRujukan={handleClickNoRujukan}
          />

          <Grid item sm={12}>
            {type === "MANUAL" ||
            isNull(formData.no_sep) ||
            formData.no_sep === "-" ? (
              <Grid container>
                <Grid item sm={3}>
                  <InputTextMaster
                    name="diagnosa_name"
                    label="DIAGNOSA"
                    id="diagnosa_name"
                    value={formData.diagnosa_name}
                    onChange={handleChange("diagnosa_name")}
                    placeholder=""
                  />
                </Grid>
                <Grid item sm={9}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <InputOptionMaster
                      name="diagnosa_awal"
                      label="DIAGNOSA AWAL"
                      id="diagnosa_awal"
                      withSearch={true}
                      value={formData.diagnosa_awal}
                      labelValue={formData.diagnosa_awal_name}
                      onChange={(e) => {
                        if (isNull(e)) {
                          setFormData({
                            ...formData,
                            diagnosa_awal: null,
                            diagnosa_awal_name: "Pilih Diagnosa",
                          })
                        } else {
                          setFormData({
                            ...formData,
                            diagnosa_awal: e.value,
                            diagnosa_awal_name: e.label,
                          })
                        }
                      }}
                      data={diagnosa}
                    />

                    {loading && <div className="small-loader mt-1"></div>}
                  </div>
                </Grid>
              </Grid>
            ) : (
              <InputTextMaster
                name="diagnosa_awal_name"
                label="DIAGNOSA"
                id="diagnosa_awal_name"
                value={formData.diagnosa_awal_name}
                onChange={handleChange("diagnosa_awal_name")}
                disabled={true}
                readOnly={true}
                placeholder=""
              />
            )}
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name="laka_lantas"
              label="LAKA LANTAS"
              id="laka_lantas"
              value={formData.laka_lantas}
              withSearch={false}
              onChange={handleChange("laka_lantas")}
              data={sebabSakitSelect}
            />
          </Grid>

          <FormHanyaJikaLakaLantas
            formData={formData}
            setFormData={setFormData}
            type={type}
            handleChange={handleChange}
            handleClickSepSuplesi={handleClickSepSuplesi}
          />

          <Grid item sm={12}>
            <InputTextMaster
              name="catatan"
              label="CATATAN"
              id="catatan"
              value={formData.catatan}
              onChange={handleChange("catatan")}
              placeholder="Catatan"
            />
          </Grid>

          <Grid item sm={12}>
            {openData && (
              <ListSEPInternal
                setOpenData={setOpenData}
                noSEP={formData.no_sep}
                formData={formData}
              />
            )}
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          className="mt-1"
          justifyContent="space-between"
          alignItems="center"
        >
          <div>
            <MasterButton
              className={"mt-1"}
              type="button"
              color="danger"
              name="RESET"
              onClick={() =>
                setFormData(
                  defaultStateSep({
                    detailSep: "",
                    registrationID: "",
                    type: "",
                    pekerjaan: "",
                    dokterNama: "",
                    dokterKodeBridge: "",
                    poliSEP: "",
                    noBPJS: "",
                    noRujukan: "",
                    noKontrol: "",
                    patientID: "",
                  }),
                )
              }
              size="md"
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            {alreadySEP && (
              <>
                <MasterButton
                  className={"mt-1"}
                  type="button"
                  color="lightgreen"
                  name="SEP INTERNAL"
                  onClick={() => setOpenData(!openData)}
                  size="md"
                />
                <MasterButton
                  className={"mt-1"}
                  type="button"
                  color="warning"
                  name="DOT"
                  onClick={handleClickPrint}
                  size="md"
                />
              </>
            )}

            <MasterButton
              className={"mt-1"}
              type="button"
              color="green"
              name="PDF"
              onClick={() => handleClickCetakSep(formData)}
              size="md"
            />

            {!alreadySEP && (
              <MasterButton
                className={"mt-1"}
                type="button"
                disabled={loadingSubmit}
                color={loadingSubmit ? "secondary" : "lightgreen"}
                name={loadingSubmit ? "Loading..." : "SIMPAN"}
                onClick={() => handleSubmit()}
                size="md"
              />
            )}

            {alreadySEP && (
              <>
                {access.access_delete_sep && (
                  <MasterButton
                    className={"mt-1"}
                    type="button"
                    disabled={loadingHapus.state}
                    color={loadingHapus.state ? "secondary" : "danger"}
                    name={loadingHapus.state ? "Loading..." : "HAPUS"}
                    onClick={() => hapusSep()}
                    size="md"
                  />
                )}
                {access.access_update_sep && (
                  <MasterButton
                    className={"mt-1"}
                    type="button"
                    disabled={loadingUbah.state}
                    color={loadingUbah.state ? "secondary" : "lightgreen"}
                    name={loadingUbah.state ? "Loading..." : "UBAH"}
                    onClick={() => ubahSep()}
                    size="md"
                  />
                )}
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  )
}

const CardProlanisPRB = ({ label }) => {
  return (
    <p
      style={{
        color: "#CC2B1D",
        backgroundColor: "#fecaca",
        padding: "10px 14px",
        borderRadius: "3px",
        marginBottom: "12px",
      }}
    >
      {label}
    </p>
  )
}
